import { render, staticRenderFns } from "./AddEditRatingistCheck.vue?vue&type=template&id=1534d786"
import script from "./AddEditRatingistCheck.vue?vue&type=script&lang=js"
export * from "./AddEditRatingistCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports